<template>
  <div class="ui-filter-checkbox" :class="{ pretty }">
    <label class="xs-title">{{ $attrs.name }}</label>
    <div class="checkboxes" :class="{ pretty }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    pretty: {
      type: Boolean,
      default() {
        return false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ui-filter-checkbox {
}
.checkboxes {
  margin-top: 1em;
  label {
    margin-bottom: 0.5em;
  }
  & > * {
    display: flex;
    align-items: center;
    input {
      margin-right: 0.5em;
    }
  }
  &.pretty {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.5em;
    label {
      margin-bottom: 0;
    }
    & > * {
      padding: 0.5em;
      border: solid 1px rgba(0, 0, 0, 0.1);
    }
  }
}
</style>
